import React from "react";
import Sidebar from "react-sidebar";
import MaterialTitlePanel from "../material_title_panel";
import SidebarContent from "../SiddebarContent";
import axios from 'axios';
import Moment from 'react-moment';
import 'moment/locale/uk'
import { Link } from "react-router-dom";
const Endpoint ="https://warm-wildwood-97173.herokuapp.com" ||"http://localhost:500"
const styles = {
  contentHeaderMenuLink: {
    textDecoration: "none",
    color: "white",
    padding: 8
  },
  content: {
    padding: "16px"
  }
};

const mql = window.matchMedia(`(min-width: 1500px)`);


const ConsultForm= props => (
    <tr>
        <td style={{fontSize:"10px"}}><Moment locale="uk" parse="YYYY-MM-DD HH:mm">{props.info._date}</Moment></td>
      <td style={{fontSize:"10px"}}><Moment locale="uk" parse="YYYY-MM-DD HH:mm">{props.info.posted_date}</Moment></td>
        <td style={{fontWeight:"bolder", fontSize:"10px"}}>{props.info.contact_name}</td>
        <td style={{fontSize:"10px"}}>0{props.info.contact_number}</td>
        <td style={{fontSize:"10px"}}>{props.info.contact_email}</td>
        <td style={{fontSize:"10px"}}>{props.info.contact_message}</td>
        
        <td style={{fontSize:"10px"}}>
            {/* <Link to={"/edit/"+props.todo._id}>Edit</Link> */}
            <Link to={"/delete_consult_list/"+props.info._id}>Delete</Link>

        </td>
    </tr>
)

 class ConsultList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      docked: mql.matches,
      open: false,
      infos: []
    };

    this.mediaQueryChanged = this.mediaQueryChanged.bind(this);
    this.toggleOpen = this.toggleOpen.bind(this);
    this.onSetOpen = this.onSetOpen.bind(this);
  }


componentDidMount() {
    axios.get(Endpoint+'/consult_form/')
        .then(response => {
            this.setState({infos: response.data});
        })
        .catch(function (error) {
            console.log(error);
        })
}

componentDidUpdate() {
    axios.get(Endpoint+'/consult_form/')
    .then(response => {
        this.setState({infos: response.data});
    })
    .catch(function (error) {
        console.log(error);
    })   
}

contactFormList() {
    return this.state.infos.map(function(currentinfos, i) {
        return <ConsultForm info={currentinfos} key={i} />;
    });
}




  componentWillMount() {
    mql.addListener(this.mediaQueryChanged);
  }

  componentWillUnmount() {
    mql.removeListener(this.mediaQueryChanged);
  }

  onSetOpen(open) {
    this.setState({ open });
  }

  mediaQueryChanged() {
    this.setState({
      docked: mql.matches,
      open: false
    });
  }

  toggleOpen(ev) {
    this.setState({ open: !this.state.open });

    if (ev) {
      ev.preventDefault();
    }
  }

  render() {
    const sidebar = <SidebarContent />;

    const contentHeader = (
      <span>
        {!this.state.docked && (
          <Link
            onClick={this.toggleOpen}
           
            style={styles.contentHeaderMenuLink}
          >
            =
          </Link>
        )}
        <span>OrchidDigital Admin Section</span>
      </span>
    );

    const sidebarProps = {
      sidebar,
      docked: this.state.docked,
      open: this.state.open,
      onSetOpen: this.onSetOpen
    };

    return (
      <Sidebar {...sidebarProps}>
        <MaterialTitlePanel title={contentHeader}>
          <div style={styles.content}>
          <div>
                <h3>Contact  List</h3>
                <table className="table table-striped" style={{ marginTop: 20, overflowX:"auto", width:"100%" }}>
                    <thead style={{background:"blue", color:"white", fontSize:"12px"}}>
                        <tr>
                        <th>Date</th>
                        <th>Consultation Date</th>
                            <th>Name</th>
                            <th>Number</th>
                            <th>Email</th>
                            <th>Message</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        { this.contactFormList().reverse() }
                    </tbody>
                </table>
                </div>
          </div>
         
        </MaterialTitlePanel>
      </Sidebar>
    );
  }
}

export default ConsultList